// import React from "react";
import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
  Link,
  useLocation,
  useNavigate,
  useParams,
  Navigate,
} from "react-router-dom";
import "./index.css";
// Also imported in index.js. The prod Jenkins job replaces src/index.js with its own copy,
// so registering it here too keeps auth on live; a module only runs once however often imported.
import "./interceptors/authInterceptor";
import Layout from "./Components/Layout/Index";

import DashboardMain from "./Components/Dashboard/DashboardMain";
import MainOrder from "./Components/Orders/MainOrder";
import EditCategory from "./Components/Category/EditCategory";
import MainAttributes from "./Components/Attributes/MainAttributes";
import MainProducts from "./Components/Products/MainProducts";
import MainVendors from "./Components/Vendors/MainVendors";
import MainTimesheet from "./Components/Timesheet/MainTimesheet";
import MainImportData from "./Components/ImportData/MainImportData";
import TopTenders from "./Components/Dashboard/TopTenders";
//import ProductTable from "./Components/Products/ProductTable";
import ProductEdit from "./Components/Products/ProductEdit";
import AddCoupon from "./Components/Coupons/AddCoupon";
// import MainStoreSetting from "./Components/StoreSetting/MainStoreSetting";
import MainReport from "./Components/ReportSetting/MainReport";
import MainAddEmployee from "./Components/StoreSetting/AddEmployee/MainAddEmployee";
import Permission from "./Components/StoreSetting/AddEmployee/Permission";
import MainSyastemAccess from "./Components/StoreSetting/SystemAccess/MainSystemAccess";
// import Info from "./Components/StoreSetting/SubSetting/Info";

import MainInventory from "./Components/StoreSetting/Inventory/MainInventory";

import MainTaxes from "./Components/StoreSetting/Taxes/MainTaxes";

// import Info from "./Components/StoreSetting/SubSetting/Info";

// import Info from "./Components/StoreSetting/SubSetting/Info";
import "./Styles/storeSettingInfo.css";

import "./Styles/AttributesPage.css";

import MainStoreOption from "./Components/StoreSetting/StoreOption/MainStoreOption";
import MainStoreAlters from "./Components/StoreSetting/StoreAlters/MainStoreAlters";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import LoadingSpinner from "./LoadingSpinner";
import { useQvTheme, useQvFlavor, getFlavorSurfaces, useQvLightTone, getLightToneSurfaces, applyThemeAttribute, installPrintGuard } from "./theme/themeManager";
import { startIconContrast } from "./theme/iconContrast";
// Semantic aliases first so pages can use --qv-brand / --qv-surface / --qv-focus.
// Generated role-hex values next; hand-written dark.css last so it can win.
import "./theme/tokens.css";
import "./theme/dark.generated.css";
import "./theme/light.generated.css";
import "./theme/light.css";
import "./theme/dark.hsl.generated.css";
import "./theme/dark.css";

import "./Styles/InventoryWorkspace.css";
import "./Styles/StoreSettingsWorkspace.css";
import "./Styles/SuperadminWorkspace.css";
import "./Styles/CategoryPage.css";
import "./Styles/AttributesPage.css";
import "./Styles/PurchasePage.css";
import "./Styles/TableOrderPage.css";
import "./Styles/MainInStore.css";
import "./Styles/MainOrderPage.css";
import "./Styles/MixAndMatch.css";
import "./Styles/CouponDiscount.css";
import "./Styles/ImportData.css";
import "./Styles/DailyDaterange.css";
// import "./Styles/EmployeeWorking.css";
import "./Styles/Table.css";
import "./Styles/DefaultsPage.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./Styles/AlertModal.css";
import "./Styles/ReceiptMainpage.css";
import "./Styles/MainCatedetails.css";
import MainResigtersetting from "./Components/StoreSetting/ResigterSetting/MainResigtersetting";
import "./Styles/ResigterSettingdata.css";
import ReceiptMainpage from "./Components/StoreSetting/Receipt/ReceiptMainpage";

import InstantActvity from "./Components/Reporting/InstantPo/InstantActvity";
import EmployeeWorking from "./Components/Reporting/EmployeeWorkingHours/EmployeeWorking";
import MainSiftSummary from "./Components/Reporting/SiftSummary/MainSiftSummary";

import CheckIDVerifyMain from "./Components/Reporting/CheckIDVerify/CheckIDVerifyMain";

import PaymentMethodReport from "./Components/Reporting/PaymentMehodDetail/PaymentMethodReport";

import NewItemCreatedBetweenMain from "./Components/Reporting/NewItemCreatedBetween/NewItemCreatedBetweenMain";
import ReorderInventoryMain from "./Components/Reporting/ReorderInventory/ReorderInventoryMain";

import MainItem from "./Components/Reporting/ItemType/MainItem";
import MainItemSales from "./Components/Reporting/ItemSales/MainItemSales";
import MainEmployeelist from "./Components/Reporting/Employelist/MainEmployeelist";
import MainTaxesReport from "./Components/Reporting/Taxes/MainTaxesReport";
import MainSalesPerson from "./Components/Reporting/SalesByPerson/MainSalesPerson";
// import Login from "./Components/Authenticate/login";
// import ForgetPassword from "./Components/Authenticate/forgetPassword/forgetPassword";
// import StoreList from './Components/StoreRcord/storeList'
// import MainInvDuplicates from "./Components/InventoryDuplicates/MainInvDuplicates";
// import Main from "./Main";
import "./Styles/OrderSummaryDetails.css";
import "./Styles/Table.css";
import LeftSide from "./Components/Layout/LeftSide";
import SideMenu from "./Components/Layout/SideMenu";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
// import InventoryExport from "./Components/InventoryExport/MainInventoryExport";
import ProtectedRoute from "./protected/protectedRoute";
import ProtectedOrderSummery from "./protected/protectedOrderSummery";
import ProtectedStoreRoute from "./protected/protectedStoreRoute";
import WebRegister from "./Components/WebRegister/WebRegister";
import PaymentCalDetails from "./Components/Reporting/SalesByPerson/MainOrderSumaaryDetails/PaymentCalDetails";
import OrderSummaryPopupInterceptor from "./reuseableComponents/OrderSummaryPopupInterceptor";
import OfflineStatusBanner from "./Components/NetworkStatus/OfflineStatusBanner";
import "./Components/NetworkStatus/OfflineStatusBanner.css";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import PrintPurchaseOrder from "./Components/PurchaseOrders/PrintPurchaseOrder";
import StocktakeReportPrint from "./Components/Stocktake/StocktakeReportPrint";
import MainNeedHelp from "./AllUserComponents/NeedHelp/MainNeedHelp";
import { emptyProduct } from "./Redux/features/Product/ProductSlice";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { useAuthDetails } from "./Common/cookiesHelper";
import { RouteErrorBoundary } from "./Components/ErrorBoundary/ErrorBoundary";
const Login = lazy(() => import("./Components/Authenticate/login"));
const ForgetPassword = lazy(
  () => import("./Components/Authenticate/forgetPassword/forgetPassword")
);
const ResetPassword = lazy(
  () => import("./Components/Authenticate/resetPassword")
);
const Main = lazy(() => import("./Main"));
// Owner Report portal: its own login, outside the back-office guards.
const OwnerPortalHome = lazy(() => import("./Components/OwnerPortal/OwnerPortalHome"));
const OwnerPortalLayout = lazy(() => import("./Components/OwnerPortal/OwnerPortalLayout"));
const OwnerPortalSettings = lazy(() => import("./Components/OwnerPortal/OwnerPortalSettings"));
const OwnerPortalLogin = lazy(() =>
  import("./Components/OwnerPortal/OwnerPortalAuth").then((m) => ({ default: m.OwnerPortalLogin }))
);
const OwnerPortalForgot = lazy(() =>
  import("./Components/OwnerPortal/OwnerPortalAuth").then((m) => ({ default: m.OwnerPortalForgot }))
);
const OwnerPortalSetPassword = lazy(() =>
  import("./Components/OwnerPortal/OwnerPortalAuth").then((m) => ({ default: m.OwnerPortalSetPassword }))
);
// Old products UI is retired; its URLs forward to the new products UI.
const OldProductRedirect = ({ to }) => {
  const { id, varientId } = useParams();
  const { search } = useLocation();
  const path =
    to === "saleshistory"
      ? `/inventory/new-products/saleshistory/${id}${varientId ? `/${varientId}` : ""}${search}`
      : to === "edit" && id
        ? `/inventory/new-products/edit/${id}`
        : to === "duplicate" && id
          ? `/inventory/new-products/duplicate/${id}`
          : to === "add"
            ? "/inventory/new-products/add"
            : "/inventory/new-products";
  return <Navigate to={path} replace />;
};
const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/dashboard");
  }, [navigate]);

  return null;
};

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTabletNav = useMediaQuery("(max-width:1024px)");
  const [isMenuOpen, setIsMenuOpen] = useState(!isTabletNav);
  const currentUrl = location.pathname;
  const [isSideBar, setIsSideBar] = useState(false);
  const { LoginGetDashBoardRecordJson } = useAuthDetails();
  // Appearance (dark tones + warm light) is open to every signed-in role.
  const canUseAppearance = Boolean(LoginGetDashBoardRecordJson?.login_type);
  const [qvTheme] = useQvTheme();
  const [qvFlavor] = useQvFlavor();
  const [qvLightTone] = useQvLightTone();
  const muiTheme = React.useMemo(() => {
    // Same signed-in gate as applyThemeAttribute: the MUI palette must follow
    // the data-theme attribute, otherwise MUI renders dark Papers on light
    // CSS. Fails safe (default light) while auth is still loading.
    const isDark = qvTheme === "dark" && canUseAppearance;
    // Shared input rim: MUI thickens the outlined border to 2px on focus, so
    // fields that only recolour on focus looked heavier than on hover. Pin the
    // focused width to 1px app-wide. Theme overrides sit below component
    // sx/styled rules, so fields that set their own focused width keep it.
    // Disabled fields show not-allowed instead of MUI's default arrow.
    const components = {
      MuiInputBase: {
        styleOverrides: {
          root: { "&.Mui-disabled": { cursor: "not-allowed" } },
          input: { "&.Mui-disabled": { cursor: "not-allowed" } },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: { "&.Mui-disabled": { cursor: "not-allowed" } },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: "1px",
            },
          },
        },
      },
    };
    // DEFAULT light MUST stay MUI's default theme apart from the input rim
    // above — that is what the app rendered before theming existed.
    // The WARM tone only swaps the two paper
    // surfaces, mirroring light.generated.css. Literal hex per the gap-7 rule.
    if (!isDark) {
      const tone = getLightToneSurfaces(qvLightTone);
      if (canUseAppearance && tone.paper) {
        return createTheme({
          palette: {
            background: { default: tone.page, paper: tone.paper },
          },
          components,
        });
      }
      return createTheme({ components });
    }
    // Surfaces follow the chosen dark FLAVOR (graphite/navy/slate/espresso).
    // The values in DARK_FLAVORS are literal hex mirrored from the token
    // generator, so CSS surfaces and MUI surfaces match exactly per flavor.
    const surf = getFlavorSurfaces(qvFlavor);
    return createTheme({
      palette: {
        mode: "dark",
        // MUI's dark palette gives primary a LIGHT main and therefore a DARK
        // contrastText. This app paints its own (dark) button backgrounds, so
        // that default rendered black-on-black labels. Pin a dark-appropriate
        // brand with white contrast text instead.
        primary:
          qvFlavor === "navy"
            ? { main: "#3554a5", light: "#9bb0d4", dark: "#2d4790", contrastText: "#ffffff" }
            : qvFlavor === "slate"
              ? { main: "#4d6b85", light: "#a8bcc9", dark: "#3f5870", contrastText: "#ffffff" }
              : qvFlavor === "espresso"
                ? { main: "#7d5535", light: "#d4b896", dark: "#6a472c", contrastText: "#ffffff" }
                : { main: "#4d8dfa", contrastText: "#ffffff" },
        secondary: { main: "#8b94a5", contrastText: "#ffffff" },
        // NOTE: these must stay literal hex (via DARK_FLAVORS). The dark-token
        // codemod rewrote them into var(--qv-tx-*) once, and because `tx` is
        // the TEXT role those tokens resolve to a near-WHITE value in dark
        // mode — which made background.paper light and turned every MUI
        // Paper/Dialog/Menu/Popover (e.g. the Edit Permissions modal) white on
        // the dark theme. This block is dark-only config; never retarget it.
        background: { default: surf.page, paper: surf.paper },
        text: { primary: "#e8eaf0", secondary: "#a0a8b7", disabled: "#717a89" },
        divider: surf.divider,
      },
      components,
    });
  }, [qvTheme, qvFlavor, qvLightTone, canUseAppearance]);

  // Dark theme route guard: keep the data-theme attribute in sync with the
  // route so excluded pages (login/auth, web-register, print views) always
  // render light regardless of the stored preference. The second argument is
  // the signed-in gate: while auth is still loading (or signed out) it is
  // false, which fails safe (light).
  useEffect(() => {
    applyThemeAttribute(location.pathname, canUseAppearance);
  }, [location.pathname, qvTheme, qvFlavor, qvLightTone, canUseAppearance]);

  // Printing is always light — see installPrintGuard().
  // Icon contrast is measured from real pixels — see iconContrast.js.
  useEffect(() => {
    installPrintGuard();
    startIconContrast();
  }, []);

  useEffect(() => {
    setIsMenuOpen(!isTabletNav);
    // if (!isTabletNav) {
    // }
  }, [isTabletNav]);

  useEffect(() => {
    if (currentUrl.split("/")[2] === "order-summary") {
      setIsSideBar(true);
    } else {
      setIsSideBar(false);
    }
  }, [currentUrl]);

  useEffect(() => {
    if (!location.pathname.includes("products")) {
      dispatch(emptyProduct([]));
    }
  }, [location]);

  // Auto logout after 1 minute of inactivity (optimized)
  useEffect(() => {
    // const INACTIVITY_LIMIT = 10 * 1000; 
    const INACTIVITY_LIMIT = 10 * 60 * 60 * 1000;
    const authPages = new Set([
      "/login",
      "/forgot-password",
      "/reset-password",
    ]);

    let timerId;

    const logout = () => {
      Cookies.remove("loginDetails");
      Cookies.remove("user_auth_record");
      Cookies.remove("token_data");
      Cookies.remove("superadmin_details");
      try {
        localStorage.clear();
      } catch (e) { }
      navigate("/login", { replace: true });
    };

    const resetTimer = () => {
      clearTimeout(timerId);

      // Don't run timer on auth pages or when not logged in
      const path = window.location.pathname;
      // The Owner Report portal (/owner/* or /merchants/owner/*) has its own
      // session; this timer's logout clears localStorage, portal token included,
      // and sends the owner to the back office's sign-in.
      const ownerPortal = /^(\/merchants)?\/owner(\/|$)/.test(path);
      if (authPages.has(path) || ownerPortal || !Cookies.get("token_data")) {
        return;
      }

      timerId = setTimeout(logout, INACTIVITY_LIMIT);
    };

    const events = ["click", "keydown", "scroll", "visibilitychange"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Initialize timer once on mount
    resetTimer();

    return () => {
      clearTimeout(timerId);
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [navigate]);

  return (
    <ThemeProvider theme={muiTheme}>
      <OfflineStatusBanner />
      <OrderSummaryPopupInterceptor />
      <RouteErrorBoundary variant="app">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route exact path="/login" element={<Login visible={"login"} />} />
            <Route path="/owner" element={<OwnerPortalLayout />}>
              <Route index element={<OwnerPortalHome />} />
              <Route path="settings" element={<OwnerPortalSettings />} />
            </Route>
            <Route exact path="/owner/login" element={<OwnerPortalLogin />} />
            <Route exact path="/owner/forgot-password" element={<OwnerPortalForgot />} />
            <Route exact path="/owner/accept-invite" element={<OwnerPortalSetPassword mode="invite" />} />
            <Route exact path="/owner/reset-password" element={<OwnerPortalSetPassword mode="reset" />} />
            <Route
              exact
              path="/forgot-password"
              element={<ForgetPassword visible={"forgot-password"} />}
            />
            <Route
              exact
              path="/reset-password"
              element={<ResetPassword visible={"reset-password"} />}
            />
            <Route
              exact
              // path="/users/view/unapprove/menu/defaults/edit-defaults/:defaultsCode"
              path="/unapprove/defaults/edit-defaults/:defaultsCode"
              element={<Main visible={"edit-defaults"} />}
            />
            <Route
              exact
              // path="/users/view/unapprove/menu/defaults/edit-defaults/:defaultsCode"
              path="/unapprove/defaults/add-defaults"
              element={<Main visible={"add-defaults"} />}
            />
            <Route
              exact
              path="/unapprove/banners/edit-banners/:defaultsCode"
              element={<Main visible={"edit-banners"} />}
            />
            <Route
              exact
              path="/unapprove/banners/add-banners"
              element={<Main visible={"add-banners"} />}
            />
            <Route
              exact
              path="/unapprove/newsletter-subscribed"
              element={<Main visible={"newsletter-subscribed"} />}
            />
            <Route
              exact
              path="/unapprove/bulk-sms-system"
              element={<Main visible={"bulk-sms-system"} />}
            />
            <Route
              exact
              path="/unapprove/restricted-keywords"
              element={<Main visible={"restricted-keywords"} />}
            />
            <Route
              exact
              path="/unapprove/restricted-keywords/add"
              element={<Main visible={"add-restricted-keyword"} />}
            />
            <Route
              exact
              path="/unapprove/restricted-keywords/edit/:id"
              element={<Main visible={"edit-restricted-keyword"} />}
            />
            <Route element={<ProtectedOrderSummery visible="manager" />}>
              <Route
                path="/order/store-reporting/order-summary/:merchant_id/:order_id"
                element={<PaymentCalDetails visible={"order-summary"} />}
              />
            </Route>
            {/* <Route element={<ProtectedOrderSummery visible="superadmin" />}>
            <Route
              path="/unapprove/refund-request/order-summary/:merchant_id/:order_id"
              element={<PaymentCalDetails visible={"order-summary"} />}
            />
          </Route> */}
            <Route element={<ProtectedStoreRoute visible="manager" />}>
              <Route exact path="/store" element={<Main visible={"store"} />} />

              <Route
                exact
                path="/manager"
                element={<Main visible={"manager"} />}
              />
            </Route>
            <Route
              path="/print-purchase-order"
              element={<PrintPurchaseOrder />}
            />
            <Route
              path="/stocktake/print-stocktake-report"
              element={<StocktakeReportPrint />}
            />

            <Route
              exact
              path="/users/view/unapprove/need-help"
              element={<MainNeedHelp />}
            />
            {/* <Route exact path="/store" element={<Main visible={"store"} />} /> */}
            <Route element={<ProtectedRoute visible="manager" />}>
              {/* Full-screen, chrome-less POS register (no <Main> shell) */}
              <Route exact path="/web-register" element={<WebRegister />} />
              <Route
                exact
                path="/manager"
                element={<Main visible={"manager"} />}
              />
              <Route path="/" element={<Home />} />
              <Route
                index
                path="/dashboard"
                element={<Main visible={"dashboard"} />}
              />
              <Route
                index
                path="/node-dashboard"
                element={<Main visible={"node-dashboard"} />}
              />
              <Route
                index
                path="/dashboard-chart-view-reports"
                element={<Main visible={"dashboard-chart-view-reports"} />}
              />
              <Route
                index
                path="/node-dashboard-chart-view-reports"
                element={<Main visible={"node-dashboard-chart-view-reports"} />}
              />
              {/* new UI */}
              <Route exact path="/order-new" element={<Main visible={"order-new"} />} />
              <Route exact path="/order-new/online-new" element={<Main visible={"order-online-new"} />} />
              <Route
                exact
                path="/order/online"
                element={<Main visible={"order-online"} />}
              />
              <Route
                exact
                path="/order/:start_date/:end_date/:order_env/:order_method"
                element={<Main visible={"order"} />}
              />
              <Route
                exact
                path="/inventory/category/add"
                element={<Main visible={"add-category"} />}
              />
              <Route
                exact
                path="/inventory/products"
                element={<OldProductRedirect />}
              />
              <Route
                path="/inventory/stock-on-hand"
                element={<Navigate to="/stock-on-hand" replace />}
              />
              <Route
                exact
                path="/inventory/products/old"
                element={<OldProductRedirect />}
              />
              <Route
                exact
                path="/inventory/bulk-product-update"
                element={<Main visible={"bulk-product-update"} />}
              />
              <Route
                exact
                path="/inventory/transfer"
                element={<Main visible={"inventory-transfer"} />}
              />
              <Route
                exact
                path="/inventory/transfer/new-transfer"
                element={<Main visible={"inventory-transfer"} />}
              />
              <Route
                exact
                path="/inventory/composite-items"
                element={<Main visible={"composite-items"} />}
              />
              <Route
                exact
                path="/inventory/composite-items/operations"
                element={<Main visible={"composite-operations"} />}
              />
              <Route
                exact
                path="/inventory/container-deposit"
                element={<Main visible={"container-deposit"} />}
              />
              <Route
                exact
                path="/inventory/packaging"
                element={<Main visible={"product-lookups"} />}
              />
              <Route
                exact
                path="/inventory/products/saleshistory/:id/:varientId"
                element={<OldProductRedirect to="saleshistory" />}
              />
              <Route path="*" element={<PageNotFound />} />

              <Route
                exact
                path="/inventory/products/saleshistory/:id"
                element={<OldProductRedirect to="saleshistory" />}
              />

              <Route
                exact
                path="/inventory/products/varient-edit/:id/:varientName"
                element={<OldProductRedirect to="edit" />}
              />

              <Route
                exact
                path="/inventory/products/edit/:id"
                element={<OldProductRedirect to="edit" />}
              />
              <Route
                exact
                path="/inventory/products/duplicate-product/:id"
                element={<OldProductRedirect to="duplicate" />}
              />

              <Route
                exact
                path="/inventory-merge"
                element={<Main visible={"inventory-merge"} />}
              />

              <Route
                exact
                path="/invertory-export"
                element={<Main visible={"inventory-export-merchant"} />}
              />

              <Route
                exact
                path="/inventory/inventory-export"
                element={<Main visible={"inventory-export-merchant"} />}
              />

              <Route
                exact
                path="/stock-on-hand"
                element={<Main visible={"stock-on-hand"} />}
              />
              <Route exact path="/audit-log" element={<Main visible={"audit-log"} />} />
              <Route
                exact
                path="/purchase-order"
                element={<Main visible={"new-purchase-order"} />}
              />
              <Route
                exact
                path="/purchase-order/add"
                element={<Main visible={"new-purchase-order-add"} />}
              />
              <Route
                exact
                path="/purchase-order/:id"
                element={<Main visible={"new-purchase-order-detail"} />}
              />
              <Route
                exact
                path="/stocktake/:pageNumber"
                element={<Main visible={"stocktake"} />}
              />
              <Route
                exact
                path="/stocktake/:pageNumber/UpdateStocktake/:id"
                element={<Main visible={"stocktake-updateStocktake"} />}
              />
              <Route
                exact
                path="/stocktake/AddStocktake"
                element={<Main visible={"stocktake-AddStocktake"} />}
              />
              <Route
                exact
                path="/stocktake/:pageNumber/void/:id"
                element={<Main visible={"stocktake-void"} />}
              />
              <Route
                exact
                path="/stocktake/:pageNumber/completed/:id"
                element={<Main visible={"stocktake-completed"} />}
              />
              <Route
                exact
                path="/stocktake-app"
                element={<Main visible={"stocktake-app-list"} />}
              />
              <Route
                exact
                path="/stocktake-app/:stocktakeId"
                element={<Main visible={"stocktake-app-session"} />}
              />
              <Route
                exact
                path="/inventory/attributes"
                element={<Main visible={"attributes"} />}
              />
              <Route
                exact
                path="/inventory/old-attributes"
                element={<Main visible={"old-attributes"} />}
              />

              <Route
                exact
                path="/store-reporting/loyalty-program"
                element={<Main visible={"loyalty-program"} />}
              />
              <Route
                exact
                path="/promotions/coupons/add"
                element={<Main visible={"add-coupons"} />}
              />
              <Route
                exact
                path="/coupons-add"
                element={<Main visible={"add-coupons"} />}
              />
              <Route
                exact
                path="/promotions/coupons/edit-coupons/:couponsCode"
                element={<Main visible={"coupons-edit-cop"} />}
              />

              <Route
                exact
                path="promotions/coupons/order-coupons"
                element={<Main visible={"order-coupons"} />}
              />
              <Route
                exact
                path="/promotions/coupons/order-coupons/add"
                element={<Main visible={"add-order-coupons"} />}
              />
              <Route
                exact
                path="/promotions/coupons/order-coupons/edit-order-coupons/:couponsCode"
                element={<Main visible={"order-coupons-edit-cop"} />}
              />
              <Route
                exact
                path="/promotions/coupons/item-coupons"
                element={<Main visible={"item-coupons"} />}
              />
              <Route
                exact
                path="/promotions/coupons/item-coupons/add"
                element={<Main visible={"add-item-coupons"} />}
              />
              <Route
                exact
                path="/promotions/coupons/item-coupons/edit-item-coupons/:couponsCode"
                element={<Main visible={"item-coupons-edit-cop"} />}
              />
              <Route
                exact
                path="/promotions/mix-and-match"
                element={<Main visible={"mix-and-match"} />}
              />
              <Route
                exact
                path="/promotions/bogo-pricing"
                element={<Main visible={"bogo-pricing"} />}
              />
              <Route
                exact
                path="/promotions/bogo-pricing/add"
                element={<Main visible={"bogo-pricing-add"} />}
              />
              <Route
                exact
                path="/promotions/mix-and-match/add"
                element={<Main visible={"add-mix-and-match"} />}
              />
              <Route
                exact
                path="/promotions/mix-and-match/update/:dealId"
                element={<Main visible={"update-mix-and-match"} />}
              />
              <Route
                exact
                path="/promotions/product-and-category-discounts"
                element={<Main visible={"product-and-category-discounts"} />}
              />
              <Route
                exact
                path="/promotions/product-and-category-discounts/add-edit"
                element={
                  <Main visible={"product-and-category-discounts-add-edit"} />
                }
              />
              <Route
                exact
                path="/promotions/product-and-category-discounts/add-edit/:id"
                element={
                  <Main visible={"product-and-category-discounts-add-edit"} />
                }
              />
              {/* <Route
              exact
              path="/inventory/mix-and-match"
              element={<Main visible={"mix-and-match"} />}
            />
            <Route
              exact
              path="/inventory/mix-and-match/add"
              element={<Main visible={"add-mix-and-match"} />}
            />
            <Route
              exact
              path="/inventory/mix-and-match/update/:dealId"
              element={<Main visible={"update-mix-and-match"} />}
            /> */}
              <Route
                exact
                path="/inventory/vendors/add"
                element={<Main visible={"vendors"} />}
              />
              <Route
                exact
                path="/inventory/vendors/edit-vendor/:code"
                element={<Main visible={"vendors"} />}
              />
              <Route
                exact
                path="/inventory/vendors/vendor-details/:code"
                element={<Main visible={"new-vendor-details"} />}
              />
              <Route
                exact
                path="/inventory/vendors"
                element={<Main visible={"vendors"} />}
              />
              <Route
                exact
                path="/inventory/category/edit-category/:categoryCode"
                element={<Main visible={"category-edit-cat"} />}
              />

              {/* ====================== */}
              <Route
                exact
                path="/timesheet-summery-table"
                element={<Main visible={"TimeSheet-Summery-Table"} />}
              />
              {/* ====================== */}
              <Route
                exact
                path="/employee/timesheets/:selectedReport"
                element={<Main visible={"timesheets"} />}
              />
              <Route
                exact
                path="/employee/new-timesheet"
                element={<Main visible={"newTimesheet"} />}
              />
              <Route
                exact
                path="/toptraders"
                element={<Main visible={"toptraders"} />}
              />
              <Route
                exact
                path="/productedit"
                element={<OldProductRedirect />}
              />
              <Route
                exact
                path="inventory/products/add"
                element={<OldProductRedirect to="add" />}
              />

              <Route exact path="/add-po" element={<Main visible={"add-po"} />} />

              <Route
                exact
                path="/store-settings/info"
                element={<Main visible={"info"} />}
              />
              <Route
                exact
                path="/store-settings/zoho"
                element={<Main visible={"zohoProductMapping"} />}
              />
              <Route
                exact
                path="/store-settings/setup"
                element={<Main visible={"setup"} />}
              />

              <Route
                exact
                path="/store-settings/Alters"
                element={<Main visible={"Alters"} />}
              />
              <Route
                exact
                path="/store-settings/options"
                element={<Main visible={"options"} />}
              />

              <Route
                path="/store-settings/permission/:employee_id"
                element={<Main visible={"permission"} />}
              />

              {/* <Route
            path="/store-reporting/order-summary/:order_id"
            element={<Main visible={"order-summary"} />}
          /> */}

              {/* <Route
              exact
              path="/store-settings/taxes"
              element={<Main visible={"taxes"} />}
            /> */}
              <Route exact path="/taxes" element={<Main visible={"taxes"} />} />
              <Route
                exact
                path="/store-settings/system-access"
                element={<Main visible={"system-access"} />}
              />
              <Route
                exact
                path="/store-settings/breaks-and-compliance"
                element={<Main visible={"breaks-and-compliance"} />}
              />
              <Route
                exact
                path="/store-settings/bulk-update"
                element={<Main visible={"bulk-store-settings"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/AltriaForm"
                element={<Main visible={"scan-data-AltriaForm"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/ReynoldsForm"
                element={<Main visible={"scan-data-ReynoldsForm"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/Dezi"
                element={<Main visible={"scan-data-Dezi"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/SyncedProducts"
                element={<Main visible={"scan-data-SyncedProducts"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/SentReports"
                element={<Main visible={"scan-data-SentReports"} />}
              />
              <Route
                exact
                path="/store-settings/scan-data/ManualUpload"
                element={<Main visible={"scan-data-ManualUpload"} />}
              />
              <Route
                exact
                path="/customer-management/customer-groups"
                element={<Main visible={"store-groups"} />}
              />
              <Route
                exact
                path="/customer-management/create-group"
                element={<Main visible={"create-group"} />}
              />
              <Route
                exact
                path="/customer-management/edit-group"
                element={<Main visible={"edit-group"} />}
              />
              <Route
                exact
                path="/loyalty-program"
                element={<Main visible={"StoreSettingloyalty-program2"} />}
              />

              <Route
                exact
                path="/store-settings/inventory"
                element={<Main visible={"inventory"} />}
              />

              <Route
                exact
                path="/store-settings/vendors-list"
                element={<Main visible={"vendors-list"} />}
              />

              <Route
                exact
                path="/store-reporting/vendors-sales-reports"
                element={<Main visible={"vendors-sales-reports"} />}
              />
              <Route
                exact
                path="/store-settings/refund-report"
                element={<Main visible={"refund-report"} />}
              />

              <Route
                exact
                path="/store-settings/order-refund-report"
                element={<Main visible={"order-refund-report"} />}
              />

              <Route
                exact
                path="/store-settings/register"
                element={<Main visible={"register"} />}
              />
              <Route
                exact
                path="/store-reporting/inventory"
                element={<Main visible={"inventory"} />}
              />
              <Route
                exact
                path="/store-reporting/daily-total-report"
                element={<Main visible={"daily-total-report"} />}
              />
              <Route
                exact
                path="/store-reporting/Details-category"
                element={<Main visible={"Details-category"} />}
              />
              <Route
                exact
                path="/store-reporting/report-sales-person"
                element={<Main visible={"report-sales-person"} />}
              />
              <Route
                exact
                path="/store-reporting/order-summary:Sales"
                element={<Main visible={"order-summary"} />}
              />

              <Route
                exact
                path="/store-reporting/id-verification"
                element={<Main visible={"id-verification"} />}
              />
              <Route
                exact
                path="/store-reporting/inventory-list"
                element={<Main visible={"inventory-list"} />}
              />
              <Route
                exact
                path="/store-reporting/profit-margin-report"
                element={<Main visible={"profit-Margin"} />}
              />

              <Route
                exact
                path="store-reporting/credit-debit-sales"
                element={<Main visible={"credit-debit-sales"} />}
              />
              <Route
                exact
                path="/store-reporting/instant-activity"
                element={<Main visible={"instant-activity"} />}
              />
              <Route
                exact
                path="/store-reporting/overall-top"
                element={<Main visible={"overall-top"} />}
              />
              <Route
                exact
                path="/store-reporting/flash-resigter"
                element={<Main visible={"flash-resigter"} />}
              />
              <Route
                exact
                path="/store-reporting/vendors-list"
                element={<Main visible={"vendors-list"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-list"
                element={<Main visible={"employee-list"} />}
              />
              <Route
                exact
                path="/store-reporting/recorder-inventory"
                element={<Main visible={"recorder-inventory"} />}
              />
              <Route
                exact
                // path="/store-reporting/zoho-connect"
                path="/zoho-connect"
                element={<Main visible={"zoho-connect"} />}
              />
              <Route
                exact
                path="/hq-connect"
                element={<Main visible={"hq-connect"} />}
              />
              <Route
                exact
                path="/lumana-connect"
                element={<Main visible={"lumana-connect"} />}
              />
              <Route
                exact
                path="/quickbooks"
                element={<Main visible={"quickbooks"} />}
              />
              {/* <Route
              exact
              path="/store-reporting/shift-summary"
              element={<Main visible={"shift-summary"} />}
            /> */}
              <Route
                exact
                path="/store-reporting/payment-method-details"
                element={<Main visible={"payment-method-details"} />}
              />
              <Route
                exact
                path="/store-reporting/order-type"
                element={<Main visible={"order-type"} />}
              />
              <Route
                exact
                path="/store-reporting/taxes-report"
                element={<Main visible={"taxes-report"} />}
              />
              <Route
                exact
                path="/store-reporting/zoho-connect"
                element={<Main visible={"zoho-connect"} />}
              />
              <Route
                exact
                path="/store-reporting/new-taxes-report"
                element={<Main visible={"new-taxes-report"} />}
              />

              <Route
                exact
                path="/employee/manage-employees"
                element={<Main visible={"manage-employees"} />}
              />
              <Route
                exact
                path="/employee/manage-employees/manage-employee-permissions/:id"
                element={<Main visible={"manage-employee-permissions"} />}
              />
              <Route
                exact
                path="/employee/permission-presets"
                element={<Main visible={"permission-presets"} />}
              />
              <Route
                exact
                path="/employee/permission-presets/add"
                element={<Main visible={"permission-presets-add"} />}
              />
              <Route
                exact
                path="/employee/permission-presets/:id"
                element={<Main visible={"permission-presets-edit"} />}
              />
              <Route
                exact
                path="/customer"
                element={<Main visible={"dashboard-customer"} />}
              />
              <Route
                exact
                path="/customer/addCustomer"
                element={<Main visible={"dashboard-customer-addCustomer"} />}
              />
              <Route
                exact
                path="/customer/editCustomer"
                element={<Main visible={"dashboard-customer-editCustomer"} />}
              />
              <Route
                exact
                path="/customer/view-customer"
                element={<Main visible={"dashboard-customer-viewCustomer"} />}
              />
              <Route
                exact
                path="customer-management"
                element={<Main visible={"customer-management"} />}
              />
              <Route
                exact
                path="/store-settings/receipt"
                element={<Main visible={"receipt"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-working-hours"
                element={<Main visible={"employee-working-hours"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-ratings-report"
                element={<Main visible={"employee-ratings-report"} />}
              />
              <Route
                exact
                path="/store-reporting/item-sales"
                element={<Main visible={"item-sales"} />}
              />
              <Route
                exact
                path="/store-reporting/item-create-between"
                element={<Main visible={"item-create-between"} />}
              />

              <Route
                exact
                path="/store-reporting/sales-report"
                element={<Main visible={"sales-report"} />}
              />

              <Route
                exact
                path="/store-reporting/new-sales-report"
                element={<Main visible={"new-sales-report"} />}
              />

              <Route
                exact
                path="/store-reporting/tip-report"
                element={<Main visible={"tip-report"} />}
              />

              <Route
                exact
                path="/store-reporting/location-report"
                element={<Main visible={"location-report"} />}
              />

              <Route
                exact
                path="/store-reporting/item-sold-report"
                element={<Main visible={"item-sold-report"} />}
              />

              <Route
                exact
                path="/store-reporting/category-sold-report"
                element={<Main visible={"category-sold-report"} />}
              />

              <Route
                exact
                path="/store-reporting/po-products-report"
                element={<Main visible={"po-products-report"} />}
              />

              <Route
                exact
                path="/store-reporting/item-sold-data"
                element={<Main visible={"item-sold-data"} />}
              />

              <Route
                exact
                path="/store-reporting/coupon-report"
                element={<Main visible={"coupon-report"} />}
              />
              <Route
                exact
                path="/store-reporting/register-activity/:selectedReport"
                element={<Main visible={"register-closures"} />}
              />
              <Route
                exact
                path="/store-reporting/register-activity/register-closures/register-closures-summery"
                element={<Main visible={"register-closures-summery"} />}
              />
              <Route
                exact
                path="/store-reporting/register-activity/register-closures/register-closures-transactions"
                element={<Main visible={"register-closures-transactions"} />}
              />
              {/* <Route
              exact
              path="/store-reporting/register-activity/pay-ins-and-payout"
              element={<Main visible={"pay-ins-and-payout"} />}
            /> */}
              <Route
                exact
                path="/store-reporting/refund-report-main/:selectedReport"
                element={<Main visible={"refund-report-main"} />}
              />
              <Route
                exact
                path="/store-reporting/lottery-payout-report"
                element={<Main visible={"lottery-payout-report"} />}
              />
              {/*  category sales summery report*/}
              <Route
                path="/store-reporting/category-sales-summery-report"
                element={<Main visible={"category-sales-summery-report"} />}
              />
              <Route
                path="/store-reporting/sales-by-hour-report"
                element={<Main visible={"sales-by-hour-report"} />}
              />
              {/* category sales summery report */}
              <Route
                exact
                path="/store-reporting/drop-cash-report"
                element={<Main visible={"drop-cash-report"} />}
              />
              <Route
                exact
                path="/store-reporting/pay-in-report"
                element={<Main visible={"pay-in-report"} />}
              />
              <Route
                exact
                path="/store-reporting/store-credit-report"
                element={<Main visible={"store-credit-report"} />}
              />
              <Route
                exact
                path="/store-reporting/detailed-loyalty-points-report"
                element={<Main visible={"detailed-loyalty-points-report"} />}
              />
              <Route
                exact
                path="/store-reporting/gift-card-report"
                element={<Main visible={"gift-card-report"} />}
              />
              <Route
                exact
                path="/store-reporting/new-customers-added-report"
                element={<Main visible={"new-customers-added-report"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-sales-per-category-report"
                element={<Main visible={"employee-sales-per-category-report"} />}
              />
              <Route
                exact
                path="/need-help"
                element={<Main visible={"need_help"} />}
              />

              <Route
                exact
                path="/store-reporting/new-item-sales-report"
                element={<Main visible={"new-item-sales-report"} />}
              />

              <Route
                exact
                path="/store-reporting/uber-reports/:selectedReport"
                element={<Main visible={"uber-reports"} />}
              />

              {/* Product issues found by the background validation worker. */}
              <Route
                exact
                path="/inventory/product-issues"
                element={<Main visible={"product-issues"} />}
              />

              {/* Customer feed: merchant posts and push notifications. */}
              <Route
                exact
                path="/customer-feed"
                element={<Main visible={"customer-feed"} />}
              />
              <Route
                exact
                path="/customer-feed/:selectedSection"
                element={<Main visible={"customer-feed"} />}
              />
              {/* Gift card list, balance and history (Android More → Gift Card). */}
              <Route
                exact
                path="/promotions/gift-card"
                element={<Main visible={"gift-card"} />}
              />
              <Route
                exact
                path="/promotions/gift-card/:giftCardId"
                element={<Main visible={"gift-card"} />}
              />
              <Route
                exact
                path="/store-reporting/new-sale-report/:selectedReport"
                element={<Main visible={"new-sale-report"} />}
              />
              {/* <Route
              exact
              path="/store-reporting/old-sales-summery"
              element={<Main visible={"old-sales-summery"} />}
            /> */}
              <Route
                exact
                path="/store-reporting/inventory-report/:selectedReport"
                element={<Main visible={"inventory-report"} />}
              />
              <Route
                exact
                path="/store-reporting/inventory-report/:selectedReport/old"
                element={<Main visible={"inventory-report"} />}
              />
              <Route
                exact
                path="/store-reporting/customer-reports/:selectedReport"
                element={<Main visible={"customer-reports"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-reports/:selectedReport"
                element={<Main visible={"employee-reports"} />}
              />
              <Route
                exact
                path="/store-reporting/employee-reports/:selectedReport/:employeeId"
                element={<Main visible={"employee-reports"} />}
              />
              {/* multiple users dashbaord */}

              <Route
                exact
                path="/users/view/unapprove/label"
                element={<Main visible={"label"} />}
              />
              <Route
                exact
                path="/store-reporting/current-inventory-value"
                element={<Main visible={"current-inventory-value"} />}
              />
              <Route
                exact
                path="/store-reporting/discount-per-sales-report"
                element={<Main visible={"discount-per-sales-person"} />}
              />
              <Route
                exact
                path="/store-reporting/item-sale-profit-report"
                element={<Main visible={"item-sales-profit-report"} />}
              />

              <Route exact path="/toptraders" element={<TopTenders />} />
              <Route
                exact
                path="/users/view/unapprove/menu/defaults/edit-defaults/:defaultsCode"
                element={<Main visible={"edit-defaults"} />}
              />
              <Route
                exact
                path="/users/view/unapprove/permission"
                element={<Main visible={"permission"} />}
              />
              <Route
                exact
                path="/import-data"
                element={<Main visible={"import-data"} />}
              />
              <Route
                exact
                path="/ask-quickvee-ai"
                element={<Main visible={"ask-quickvee-ai"} />}
              />
              <Route
                exact
                path="/Digital-marketing-tags"
                element={<Main visible={"Digital-marketing-tags"} />}
              />
              <Route exact path="/inventory/category" element={<Main visible={"category"} />} />
              <Route exact path="/inventory/brands" element={<Main visible={"brands"} />} />
              <Route exact path="/inventory/tags" element={<Main visible={"tags"} />} />
              <Route exact path="/inventory/attributes" element={<Main visible={"attributes"} />} />
              <Route exact path="/inventory/new-products" element={<Main visible={"new-products"} />} />
              <Route exact path="/inventory/variants" element={<Main visible={"variants"} />} />
              <Route exact path="/inventory/new-products/add" element={<Main visible={"new-product-add"} />} />
              <Route exact path="/inventory/new-products/edit/:id" element={<Main visible={"new-product-edit"} />} />
              <Route exact path="/inventory/new-products/duplicate/:id" element={<Main visible={"new-product-duplicate"} />} />
              <Route exact path="/inventory/new-products/saleshistory/:id" element={<Main visible={"new-product-sales"} />} />
              <Route exact path="/inventory/new-products/saleshistory/:id/:varientId" element={<Main visible={"new-product-sales"} />} />
              <Route
                exact
                path="/inventory/lottery"
                element={<Main visible={"lottery"} />}
              />
              <Route
                exact
                path="/inventory/lottery/add-lottery"
                element={<Main visible={"add-lottery"} />}
              />
              <Route
                exact
                path="/inventory/lottery/update-lottery/:id"
                element={<Main visible={"update-lottery"} />}
              />
              <Route
                exact
                path="/store-reporting/payment-report"
                element={<Main visible={"payment-report"} />}
              />
            </Route>

            {/* ------------------------Superadmin---------------- */}
            <Route element={<ProtectedRoute visible="superadmin" />}>
              <Route
                exact
                path="/users/manager_view"
                element={<Main visible={"manager_view"} />}
              />
              {/* <Route
            exact
            path="/import-data"
            element={<Main visible={"import-data"} />}
          /> */}
              {/* <Route
            exact
            path="/need-help"
            element={<Main visible={"need_help"} />}
          /> */}
              <Route
                exact
                path="/users/unapprove"
                element={<Main visible={"unverified"} />}
              />
              <Route
                exact
                path="/users/unapprove/old"
                element={<Main visible={"unverified"} />}
              />
              {/* Superadmin Customers page removed; old links land on Live Stores. */}
              <Route
                exact
                path="/users/customer"
                element={<Navigate to="/users/approve" replace />}
              />
              <Route
                exact
                path="/users/superadmin_list"
                element={<Main visible={"superadmin_list"} />}
              />
              <Route
                exact
                path="/users/superadmin_list/add-superadmin"
                element={<Main visible={"superadmin-add"} />}
              />
              <Route
                exact
                path="/users/superadmin_list/edit-superadmin/:id"
                element={<Main visible={"superadmin-edit"} />}
              />
              <Route
                exact
                path="/users/superadmin_list/permission-add"
                element={<Main visible={"permission-add"} />}
              />
              <Route
                exact
                path="/users/superadmin_list/permission-edit/:id"
                element={<Main visible={"permission-edit"} />}
              />
              <Route
                exact
                path="/users/customer/old"
                element={<Navigate to="/users/approve" replace />}
              />
              <Route
                exact
                path="/users/admin"
                element={<Main visible={"admin"} />}
              />
              <Route
                exact
                path="/users/approve"
                element={<Main visible={"verified"} />}
              />
              <Route
                exact
                path="/users/approve/old"
                element={<Main visible={"verified"} />}
              />
              {/* <!-- add merchant route --> */}
              <Route
                exact
                path="/users/merchant"
                element={<Main visible={"merchant"} />}
              />
              {/* <!-- add merchant route --> */}
              <Route
                exact
                path="/users/merchant/old"
                element={<Main visible={"merchant"} />}
              />
              <Route
                exact
                path="/users/merchant/:id"
                element={<Main visible={"merchantDetail"} />}
              />
              <Route
                exact
                path="/users/editCustomer/:id"
                element={<Navigate to="/users/approve" replace />}
              />
              <Route
                exact
                path="/users/admin/addAdmin"
                element={<Main visible={"addAdmin"} />}
              />
              <Route
                exact
                path="/users/unapprove/editMerchant/:id"
                element={<Main visible={"editMerchant"} />}
              />
              <Route
                exact
                path="/users/approve/editMerchant/:id"
                element={<Main visible={"editMerchant"} />}
              />
              <Route
                exact
                path="/users/admin/editAdmin/:id"
                element={<Main visible={"editAdmin"} />}
              />
              <Route
                exact
                path="/users/merchant/addMerchant/:id"
                element={<Main visible={"addMerchant"} />}
              />
              <Route
                exact
                path="/users/merchant/addMerchant/:id/:merchantId"
                element={<Main visible={"addMerchant"} />}
              />
              <Route
                exact
                path="/users/approve/editMerchant/:id/:merchantId"
                element={<Main visible={"addMerchant"} />}
              />
              <Route
                exact
                path="/users/unapprove/editMerchant/:id/:merchantId"
                element={<Main visible={"addMerchant"} />}
              />
              <Route
                exact
                path="/users/merchant/addMerchant"
                element={<Main visible={"addMerchant"} />}
              />

              <Route
                exact
                path="/users/view/unapprove/newsletter"
                element={<Main visible={"newsletter"} />}
              />
              <Route
                exact
                path="/unapprove/store-order"
                element={<Main visible={"store-order"} />}
              />
              <Route
                exact
                path="/unapprove/refund-request"
                element={<Main visible={"refund-request"} />}
              />
              <Route
                exact
                path="/unapprove/order-count"
                element={<Main visible={"order-count"} />}
              />
              <Route
                exact
                // path="/users/view/unapprove/menu/defaults"
                path="/unapprove/defaults"
                element={<Main visible={"defaults"} />}
              />
              <Route
                exact
                path="/unapprove/banners"
                element={<Main visible={"banners"} />}
              />
              <Route
                exact
                path="/users/view/unapprove/release_apk"
                element={<Main visible={"release_apk"} />}
              />
              <Route
                exact
                path="/unapprove/inverntory-duplicate"
                element={<Main visible={"inverntory-duplicate"} />}
              />
              <Route
                exact
                path="unapprove/category-duplicate"
                element={<Main visible={"category-duplicate"} />}
              />
              <Route
                exact
                path="/unapprove/product-duplicate"
                element={<Main visible={"product-duplicate"} />}
              />
              <Route
                exact
                path="/unapprove/create_permission"
                element={<Main visible={"create_permission"} />}
              />
              <Route
                exact
                path="/unapprove/Configure_Categories"
                element={<Main visible={"Configure_Categories"} />}
              />
              <Route
                exact
                path="/unapprove/Quickvee-Custom"
                element={<Main visible={"Quickvee-Custom"} />}
              />
              <Route
                exact
                path="/unapprove/Quickvee-Custom/add-Quickvee-Custom"
                element={<Main visible={"Quickvee-Custom-add"} />}
              />
              <Route
                exact
                path="/unapprove/Quickvee-Custom/edit-Quickvee-Custom/:id"
                element={<Main visible={"Quickvee-Custom-edit"} />}
              />
              <Route
                exact
                path="/unapprove/create_main_permission"
                element={<Main visible={"create_main_permission"} />}
              />
              <Route
                exact
                path="/unapprove/invertory-export"
                element={<Main visible={"invertory-export"} />}
              />
              <Route
                exact
                path="/unapprove/merchants-export"
                element={<Main visible={"customer-export"} />}
              />
              <Route
                exact
                path="/unapprove/customer-export"
                element={<Main visible={"customer-export"} />}
              />
              <Route
                exact
                path="/unapprove/order-wise-export"
                element={<Main visible={"order-wise-export"} />}
              />
              <Route
                exact
                path="/unapprove/item-wise-export"
                element={<Main visible={"item-wise-export"} />}
              />
              <Route
                exact
                path="/unapprove/product-profitability-export"
                element={<Main visible={"product-profitability-export"} />}
              />
              <Route
                exact
                path="/unapprove/tip-report-export"
                element={<Main visible={"tip-report-export"} />}
              />
              <Route
                exact
                path="/unapprove/purchase-order-report-export"
                element={<Main visible={"purchase-order-report-export"} />}
              />
              <Route
                exact
                path="/unapprove/sales-by-category-per-employee-export"
                element={
                  <Main visible={"sales-by-category-per-employee-export"} />
                }
              />
              <Route
                exact
                path="/unapprove/sales-by-tender-export"
                element={<Main visible={"sales-by-tender-export"} />}
              />
              <Route
                exact
                path="/unapprove/order-retrieve"
                element={<Main visible={"order-retrieve"} />}
              />
              <Route
                exact
                path="/unapprove/support-details"
                element={<Main visible={"support-details"} />}
              />
              <Route
                exact
                path="/unapprove/product-sync"
                element={<Main visible={"product-sync"} />}
              />
              <Route
                exact
                path="/unapprove/report-sync"
                element={<Main visible={"report-sync"} />}
              />
              <Route
                exact
                path="/unapprove/audit-log"
                element={<Main visible={"superadmin-audit-log"} />}
              />
              <Route
                exact
                path="/unapprove/owner-report"
                element={<Main visible={"owner-report-admin"} />}
              />
              <Route
                exact
                path="/users/view/unapprove/merchant-details"
                element={<Main visible={"merchant-details"} />}
              />
              <Route
                exact
                path="/unapprove/all-inventory-update"
                element={<Main visible={"all-inventory-update"} />}
              />


              <Route
                exact
                path="/unapprove/Feature-Announcements"
                element={<Main visible={"Feature-Announcements"} />}
              />
              <Route
                exact
                path="/unapprove/Feature-Announcements/add-Feature-Announcements"
                element={<Main visible={"Feature-Announcements-add"} />}
              />
              <Route
                exact
                path="/unapprove/Feature-Announcements/edit-Feature-Announcements/:id"
                element={<Main visible={"Feature-Announcements-edit"} />}
              />
            </Route>

            {/* -----------------=============superadmin===========------------------- */}

            {/* <Route exact path="/" element={<DashboardMain />} /> */}

            {/* <Route path="/report" element={<MainReport />} /> */}
            {/* <Route path="/store-settings/taxes" element={<MainTaxes />} /> */}

            {/* <Route path="/store-settings/info"  element={<MainStoreOption />} /> */}
            {/* <Route path="/store-settings/options" element={<MainStoreOption />} /> */}
            {/* <Route

      <Route exact path="/users/view/unapprove" element={<Main  visible={"multimerchant"} />} />
      <Route exact path="/dashboard" element={<Main  visible={"dashboard"} />} />
      <Route exact path="/order" element={<Main  visible={"order"} />} />
      <Route exact path="/category" element={<Main  visible={"old-category"} />} />
      <Route exact path="/products" element={<Main  visible={"products"} />} />
      <Route exact path="/purchase-data" element={<Main  visible={"purchase-data"} />} />
      <Route exact path="/import-data" element={<Main  visible={"import-data"} />} />
      <Route exact path="/coupons" element={<Main  visible={"coupons"} />} />
      <Route exact path="/category/edit-category/:categoryCode" element={<Main  visible={"category-edit-cat"} />} />
      <Route exact path="/timesheet" element={<Main  visible={"timesheet"} />} />
      <Route exact path="/toptraders" element={<Main  visible={"toptraders"} />} />
      <Route exact path="/productedit" element={<Main  visible={"productedit"} />} />
      <Route exact path="/productedit" element={<Main  visible={"productedit"} />} />
      <Route exact path="/store-settings/info" element={<Main  visible={"info"} />} />
      <Route exact path="/store-settings/setup" element ={<Main visible={"setup"} />} />
   
      <Route exact path="/store-settings/Alters" element ={<Main visible={"Alters"} />} />
      <Route exact path="/store-settings/options" element ={<Main visible={"options"} />} />
      <Route exact path="/store-settings/taxes" element ={<Main visible={"taxes"} />} />
      <Route exact path="/store-settings/system-access" element ={<Main visible={"system-access"} />} />
      <Route exact path="/store-settings/inventory" element ={<Main visible={"inventory"} />} />
      <Route exact path="/store-reporting/register" element ={<Main visible={"register"} />} />
      <Route exact path="/store-reporting/inventory" element ={<Main visible={"inventory"} />} />
      <Route exact path="/store-reporting/daily-total-report" element ={<Main visible={"daily-total-report"} />} />
     <Route exact path="/store-reporting/Details-category" element ={<Main visible={"Details-category"} />} />
     <Route exact path="/store-reporting/report-sales-person" element ={<Main visible={"report-sales-person"} />} />
     <Route exact path="/store-reporting/id-verification" element ={<Main visible={"id-verification"} />} />
     
     <Route exact path="store-reporting/credit-debit-sales" element ={<Main visible={"credit-debit-sales"} />} />
     <Route exact path="/store-reporting/instant-activity" element ={<Main visible={"instant-activity"} />} />
     <Route exact path="/store-reporting/overall-top" element ={<Main visible={"overall-top"} />} />
     <Route exact path="/store-reporting/flash-resigter" element ={<Main visible={"flash-resigter"} />} />
     <Route exact path="/store-reporting/vendors-list" element ={<Main visible={"vendors-list"} />} />
     <Route exact path="/store-reporting/employee-list" element ={<Main visible={"employee-list"} />} />
     
     <Route exact path="/store-reporting/recorder-inventory" element ={<Main visible={"recorder-inventory"} />} />
     
     <Route exact path="/store-reporting/shift-summary" element ={<Main visible={"shift-summary"} />} />
     <Route exact path="/store-settings/payment-method-detail-report" element={<Main visible={"payment-method-detail-report"} />} />
     <Route exact path ="/store-reporting/order-type" element={<Main visible={"order-type"} />} />
     <Route exact path="/store-reporting/taxes" element={<Main visible={"taxes"} />} />

   

     {/* multiple users dashbaord */}

            {/* <Route
            exact
            path="/users/view/unapprove/category-duplicate"
            element={<Main visible={"category-duplicate"} />}
          /> */}

            {/* <Route
            exact
            path="/users/view/unapprove/invertory-export"
            element={<Main visible={"invertory-export"} />}
          /> */}

            {/* <Route exact path="/" element={<DashboardMain />} /> */}

            {/* <Route path="/store-settings/info"  element={<MainStoreOption />} /> */}

            {/* /store-settings/inventory */}
            {/* <Route path="/store-reporting/inventory" element={<MainInventory />} /> */}

            {/* <Route
          path="/store-reporting/employee-list"
          element={<MainEmployeelist />}
        /> */}

            {/* <Route
          path="/store-reporting/permission/:employee_id"
          element={<Permission />}
        /> */}

            {/* <Route
          path="/store-reporting/id-verification"
          element={<CheckIDVerifyMain />}
        /> */}
            {/* <Route path="/store-reporting/order-type" element={<MainItem />} />
        <Route path="/store-reporting/item-sales" element={<MainItemSales />} />
        <Route path="/store-reporting/taxes" element={<MainTaxesReport />} /> */}

            {/* <Route
          path="/store-settings/payment-method-detail-report"
          element={<PaymentMethodReport />}
        /> */}

            {/* <Route
          path="/store-settings/item-create-between"
          element={<NewItemCreatedBetweenMain />}
        /> */}
            {/* 
        <Route
          path="/store-settings/recorder-inventory"
          element={<ReorderInventoryMain />}
        /> */}
          </Routes>
        </Suspense>
      </RouteErrorBoundary>
    </ThemeProvider>
  );
}
export default App;
